namespace Matrix.DataAudit {
    export namespace SecurityHistoryService {
        export const baseUrl = 'DataAudit/SecurityHistory';

        export declare function Create(request: Serenity.SaveRequest<SecurityHistoryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SecurityHistoryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SecurityHistoryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: SecurityHistoryListRequest, onSuccess?: (response: Serenity.ListResponse<SecurityHistoryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetDateMatch(request: SecurityHistoryGetDateMatchRequest, onSuccess?: (response: Serenity.RetrieveResponse<SecurityHistoryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "DataAudit/SecurityHistory/Create",
            Update = "DataAudit/SecurityHistory/Update",
            Delete = "DataAudit/SecurityHistory/Delete",
            Retrieve = "DataAudit/SecurityHistory/Retrieve",
            List = "DataAudit/SecurityHistory/List",
            GetDateMatch = "DataAudit/SecurityHistory/GetDateMatch"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetDateMatch'
        ].forEach(x => {
            (<any>SecurityHistoryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
